/**
 * MTS Storage – Shared localStorage utility for MoveToShop theme features.
 * Used by: Recently Viewed, Bike Compare, Wishlist
 */
(function () {
  'use strict';

  var DEFAULTS = {
    'mts-recently-viewed': 8,
    'mts-compare': 3,
    'mts-wishlist': 50
  };

  var MtsStorage = {
    _parse: function (key) {
      try {
        return JSON.parse(localStorage.getItem(key)) || [];
      } catch (e) {
        return [];
      }
    },

    _save: function (key, items) {
      try {
        localStorage.setItem(key, JSON.stringify(items));
      } catch (e) { /* quota exceeded – silent fail */ }
      document.dispatchEvent(new CustomEvent('mts:storage-changed', {
        detail: { key: key, items: items }
      }));
    },

    getItems: function (key) {
      return this._parse(key);
    },

    addItem: function (key, item) {
      var max = DEFAULTS[key] || 50;
      var items = this._parse(key);
      // deduplicate by handle
      items = items.filter(function (i) { return i.handle !== item.handle; });
      items.unshift(item);
      if (items.length > max) items = items.slice(0, max);
      this._save(key, items);
      return items;
    },

    removeItem: function (key, handle) {
      var items = this._parse(key).filter(function (i) { return i.handle !== handle; });
      this._save(key, items);
      return items;
    },

    toggleItem: function (key, item) {
      if (this.hasItem(key, item.handle)) {
        return { items: this.removeItem(key, item.handle), added: false };
      }
      return { items: this.addItem(key, item), added: true };
    },

    hasItem: function (key, handle) {
      return this._parse(key).some(function (i) { return i.handle === handle; });
    },

    getCount: function (key) {
      return this._parse(key).length;
    },

    clear: function (key) {
      this._save(key, []);
    }
  };

  window.MtsStorage = MtsStorage;
})();
